import { services } from '@billow/js-helpers'

export default class User {

  constructor(user = {}) {
    this.id = user.id || null
    this.name = user.name || ''
    this.email = user.email || ''
    this.password = user.password || ''
    this.password_confirmation = user.password_confirmation || ''
  }

  commonMutations() {
    return {
      updateName: (state, name) => state.user.name = name,
      updateEmail: (state, email) => state.user.email = email,
      setUser: (state, user) => state.user = new User(user),
      clearUser: (state) => state.user = new User(),
    }
  }
  
  authMutations() {
    return {
      updatePassword: (state, payload) => state.user.password = payload,
      updatePasswordConfirmation: (state, payload) => state.user.password_confirmation = payload,
      deleteToken: (state) => {
        state.user = new User()
        services.auth.destroyToken()
      },
    }
  }

}